import { createStore, applyMiddleware, combineReducers } from 'redux'
import thunk from 'redux-thunk'
import { createMiddleware } from 'redux-api-middleware'
import { composeWithDevTools } from 'redux-devtools-extension'

import { reducer as companyReducer, NAME as COMPANIES_NAME } from './modules/Companies/reducer'
import { reducer as rootReducer, NAME as ROOT_NAME } from './modules/Root/reducer'
import { reducer as monitorReducer, NAME as MONITOR_NAME } from './modules/Monitor/reducer'
import { reducer as productTypeReducer, NAME as PRODUCT_TYPE_NAME } from './modules/ProductType/reducer'
import { reducer as productReducer, NAME as PRODUCT_NAME } from './modules/Product/reducer'
import { reducer as whatsappReducer, NAME as WHATSAPP_NAME } from './modules/Whatsapp/reducer'
import { reducer as authReducer, NAME as AUTH_NAME, types as authTypes } from './modules/Auth/reducer'
import { saveFeedback } from './modules/Root/saveFeedback'
import sessionFetch, { setUnauthorizedHandler } from './middleware/sessionFetch'

// Sends the session cookie with every call and notices when it stops working.
const apiMiddleware = createMiddleware({ fetch: sessionFetch })


const appReducer = combineReducers({
  [COMPANIES_NAME]: companyReducer,
  [ROOT_NAME]: rootReducer,
  [MONITOR_NAME]: monitorReducer,
  [PRODUCT_TYPE_NAME]: productTypeReducer,
  [PRODUCT_NAME]: productReducer,
  [WHATSAPP_NAME]: whatsappReducer,
  [AUTH_NAME]: authReducer,
})

const store = createStore(
  appReducer,
  {},
  composeWithDevTools(applyMiddleware(thunk, apiMiddleware, saveFeedback))
)

// Any 401 from the API means the session is gone, wherever it was noticed.
setUnauthorizedHandler(() => store.dispatch({ type: authTypes.SESSION_EXPIRED }))

export default store